<script>
  import Vue from 'vue';
  import VueSlider from 'vue-slider-component'

  export default {
    name: 'DynamicDisease',
    components: {
      VueSlider
    },
    props: {
      'disease-json': String,
      'crop-outline-json': String,
      'crop-img-src': String,
      'disease-img-src': String,
      'is-quiz': Boolean,
      'initial-percent': {
        type: [Number, String],
        default: 20
      }
    },
    data() {
      return {
        //Setup Variables
        ps: null, //The p5 object
        canvas: null,
        slider: 0,
        loading: true,
        sliderUpdated: false,
        growDisease: true,

        //Images
        cropImage: null,
        diseaseImage: null,

        //Disease Stuff
        disease: null,
        minDiseaseWidth: 0,
        maxDiseaseWidth: 0,
        useDefaultBlendMode: false,

        //Crop Stuff
        cropOutline: null,
        initialPixels: null, //Initial rendered crop image
        cropLimits: null, //Max and min x, y vertex for crop coutline
        cropArea: 0,

        //Nodes
        hiddenNodes: [],
        placedNodes: [],
        coverage: 0,

        //Canvas variables
        width: 0,
        height: 0

      }
    },

    watch: {
      slider() {
        this.sliderUpdated = true
        this.growDisease = this.coverage < this.slider
        this.ps.loop() //Continue p5.draw()
      },
      initialPercent() {
        this.slider = this.initialPercent
      }
    },

    //Called Before p5
    created() {
      // Setup Disease
      let disease = JSON.parse(this.diseaseJson)

      if (disease.min == undefined)
        disease.min = 10
      if (disease.max == undefined)
        disease.max = 20
      if (disease.min < 1)
        disease.min = 1
      if (disease.max < 3)
        disease.max = 2
      if (disease.ratio == undefined)
        disease.ratio = 1
      if (disease.outline == undefined || disease.outline == null || disease.outline == "[]" || disease.outline == 'null')
        disease.outline = null


      // Setup boundaries for outline and intersection of disease nodes
      let maxx, maxy, area, dwidth, dheight
      maxx = maxy = area = dwidth = dheight = 1

      let minx = 0
      let miny = 0

      if (disease.outline) {
        maxx = maxy = minx = miny = null
        let outline = JSON.parse(disease.outline)

        //Find disease attributes as percentage of entire Node for resizing

        for (var i in outline) {
          let node = outline[i]
          if (minx == null || node.x < minx)
            minx = node.x
          if (miny == null || node.y < miny)
            miny = node.y
          if (maxx == null || node.x > maxx)
            maxx = node.x
          if (maxy == null || node.y > maxy)
            maxy = node.y

        }

        //Percentages of entire disease image of just the outlined disease

        dwidth = maxx - minx
        dheight = maxy - miny
        area = this.calcPolygonArea(outline)

        disease.outline = outline
      }

      // Attributes that are a % of the size of a disease node
      disease["d"] = {}
      disease["d"]["width"] = dwidth
      disease["d"]["height"] = dheight
      disease["d"]["maxx"] = maxx
      disease["d"]["minx"] = minx
      disease["d"]["maxy"] = maxy
      disease["d"]["miny"] = miny
      disease["d"]["area"] = area

      this.disease = disease
    },

    //Main P5 stuff
    mounted() {

      this.script = p => {
        //First Function -> Load and render image details
        p.preload = _ => {
          const cors = "?t=" + new Date().getTime();

          this.cropImage = p.loadImage(this.cropImgSrc + cors)
          this.diseaseImage = p.loadImage(this.diseaseImgSrc + cors)

          //Get canvas width and height
          var parent = document.getElementById("canvas");
          var myImg = document.querySelector("#hidden-crop-image");
          let disImg = document.querySelector("#hidden-disease-image");

          this.disease.ratio = disImg.naturalWidth / disImg.naturalHeight
          var realWidth = myImg.naturalWidth;
          var realHeight = myImg.naturalHeight;

          this.width = parent.clientWidth
          this.height = (this.width * realHeight) / realWidth
          this.cropArea = this.width * this.height

          let width = parent.clientWidth
          this.minDiseaseWidth = Math.round(this.disease.min * .01 * width);
          this.maxDiseaseWidth = Math.round(this.disease.max * .01 * width);

          //Crop outline
          let outline = null
          try {
            outline = JSON.parse(this.cropOutlineJson)
          } catch (err) {
            console.error('No crop outline')
          }

          this.cropLimits = {
            x: {
              min: 0,
              max: this.width,
            },
            y: {
              min: 0,
              max: this.height
            }
          }

          // Set crop outline and limits
          if (outline) {
            let minx, miny, maxx, maxy = null
            this.cropOutline = []

            for (var i = 0; i < outline.length; i++) {
              let x = Math.round(outline[i].x * this.width)
              let y = Math.round(outline[i].y * this.height)

              if (x < minx || minx == null)
                minx = x
              if (x > maxx || maxx == null)
                maxx = x
              if (y < miny || miny == null)
                miny = y
              if (y > maxy || maxy == null)
                maxy = y

              this.cropOutline.push({
                x: x,
                y: y
              })
            }

            this.cropLimits = {
              x: {
                min: minx,
                max: maxx
              },
              y: {
                min: miny,
                max: maxy
              }
            };

            this.cropArea = this.calcPolygonArea(this.cropOutline)

          } //END Crop outline setup

        }
        //Called after all images are loaded and setup is complete
        p.setup = _ => {
          this.canvas = p.createCanvas(this.width, this.height)
          this.canvas.parent(this.$refs.canvas)
          p.frameRate(60)

          //Place crop image on canvas
          this.renderCropImage()


          //Crop out disease image with disease outline
          if (!!this.disease.outline) {
            let diseaseOutline = []
            this.diseaseImage.loadPixels()
            let out = this.disease.outline

            const width = this.diseaseImage.width
            const height = this.diseaseImage.height

            //Format outline to size of disease image
            for (var i in out) {
              diseaseOutline.push({
                x: (out[i].x * width),
                y: (out[i].y * height)
              })
            }

            let x, y;
            // Crop out disease
            let pt = {
              x: 0,
              y: 0
            }
            for (y = 0; y < this.diseaseImage.height; y++) {
              pt.y = y
              for (x = 0; x < this.diseaseImage.width; x++) {
                pt.x = x

                if (!this.inside(pt, diseaseOutline)) {
                  let index = (x + y * width) * 4
                  this.diseaseImage.pixels[index + 3] = 0
                }
              }
            }
            this.diseaseImage.updatePixels();
          } //END disease outline stuff

          this.initNodes() //Create Node Grid
          this.loading = false

          //Get the blank image pixels
          try {
            let t = p.get(0, 0, this.width, this.height)
            t.loadPixels()
            this.initialPixels = t.pixels;

          } catch (e) {
            console.error(e)
            console.log(p)
            alert('An error occured please reload page')
            //IDK what causes this error to sometimes occur
          }

          //Set the initial percent to render
          const initial = parseInt(this.initialPercent)
          if (initial > 80 || initial < 0)
            this.slider = 20
          else
            this.slider = initial
        }

        //Called Every Frame when ps.loop()
        //Pauses when ps.noLoop()
        p.draw = _ => {
          if (this.sliderUpdated)
            this.updateNodes()
        }
      }
      const P5 = require('p5')
      this.ps = new P5(this.script)
    },

    methods: {
      //Place crop image on canvas
      renderCropImage() {
        this.ps.blendMode(this.ps.REPLACE);
        this.ps.image(this.cropImage, 0, 0, this.width, this.height)
      },
      //Place all disease nodes on canvas
      renderDiseaseImages() {
        //If the blend mode cuases diseases to not render
        //Change blend mode to default
        if (this.placedNodes.length > 0 && this.coverage == 0)
          this.useDefaultBlendMode = true

        if (this.useDefaultBlendMode)
          this.ps.blendMode(this.ps.BLEND)
        else if (this.disease.blend_mode == 0)
          this.ps.blendMode(this.ps.LIGHTEST);
        else if (this.disease.blend_mode == 1)
          this.ps.blendMode(this.ps.DARKEST);
        else if (this.disease.blend_mode == 2)
          this.ps.blendMode(this.ps.LIGHTEST);
        else if (this.disease.blend_mode == 3)
          this.ps.blendMode(this.ps.HARD_LIGHT);
        else if (this.disease.blend_mode == 4)
          this.ps.blendMode(this.ps.SOFT_LIGHT);
        else
          this.ps.blendMode(this.ps.BLEND); //Default blend mode


        for (let i in this.placedNodes) {
          let node = this.placedNodes[i];
          this.ps.translate(node.x, node.y)
          this.ps.rotate(this.ps.radians(node.rotation))
          this.ps.image(this.diseaseImage, 0, 0, node.w, node.h)
          this.ps.rotate(this.ps.radians(-node.rotation))
          this.ps.translate(-node.x, -node.y)
        }

        this.updateCoverage()
      },
      addNode() {
        this.placedNodes.push(this.hiddenNodes.splice(Math.random() * this.hiddenNodes.length, 1)[0]);
      },
      removeNode() {
        this.hiddenNodes.push(this.placedNodes.splice(Math.random() * this.placedNodes.length, 1)[0]);
      },
      swapNodes(fromNodes, toNodes, targetArea, cluster = 0) {
        let nodes = []
        let area = 0
        let flag = 0

        //While we want more area and can pull more nodes
        while (area < targetArea && fromNodes.length > 0) {
          //Get a random node
          var nodeIndex = Math.random() * fromNodes.length

          // If cluster find a neighbor of existing found nodes
          if (nodes.length && !!cluster) {
            //Find random current node
            var index = Math.floor(Math.random() * nodes.length)
            var node = nodes[nodes.length - 1]
            var i = 0;
            //Search through neighbors until found or iteration > cluster
            while (i++ < cluster && node.neighbors.length > 0) {

              index = Math.floor(Math.random() * node.neighbors.length)
              node = node.neighbors[index]


              // If neighbor isn't already selected
              if (nodes.indexOf(node) == -1) {
                let tmpIndex = fromNodes.indexOf(node)
                // If neighbor is in empty
                if (tmpIndex > -1) {
                  nodeIndex = tmpIndex
                  break;
                }
              }
            }
          }
          //Remove node
          let node = fromNodes.splice(nodeIndex, 1)[0]
          area += node.area
          nodes.push(node)

          //Safety flag
          if (flag++ > 1000)
            break;
        }
        //Add nodes
        toNodes.push(...nodes)
        //Return approximate node area i.e. doesn't account for overlap
        return area
      },
      updateNodes() {
        //If percent is 0 just remove nodes from placed
        if (this.slider <= 0) {
          this.hiddenNodes.push(...this.placedNodes)
          this.placedNodes = []
          this.renderCropImage()
          this.updateCoverage()
          this.approxNodeArea = 0
          this.sliderUpdated = false
          this.ps.noLoop()
          return
        }

        //Speedup generation by approximating required area
        const targetArea = Math.abs(this.slider * .01 * this.cropArea - this.approxNodeArea)

        // Add nodes
        if (this.growDisease) {
          if (this.coverage < this.slider && this.hiddenNodes.length > 0) {
            this.swapNodes(this.hiddenNodes, this.placedNodes, targetArea, this.disease.offset)
            this.renderDiseaseImages()
          } else {
            this.ps.noLoop()
            this.sliderUpdated = false
          }

        }
        //Remove Nodes
        else {
          if (this.coverage > this.slider && this.placedNodes.length > 0) {
            this.swapNodes(this.placedNodes, this.hiddenNodes, targetArea)
            this.renderCropImage()
            this.renderDiseaseImages()
          } else {
            this.ps.noLoop()
            this.sliderUpdated = false
          }
        }

        this.updateCoverage()
      },
      updateCoverage() {
        //Amount of differnt pixels in p1 and p2
        let compare = (p1, p2) => {
          let diff = 0
          for (var i = 0; i < p1.length / 4; i++) {
            diff += p1[4 * i + 0] != p2[4 * i + 0]
            diff += p1[4 * i + 1] != p2[4 * i + 1]
            diff += p1[4 * i + 2] != p2[4 * i + 2]
            // diff += p1[4 * i + 3] == p2[4 * i + 3]
          }

          return diff
        }

        // this.disimg.loadPixels();

        let current = this.ps.get(0, 0, this.width, this.height)
        current.loadPixels()

        let diff = compare(current.pixels, this.initialPixels)

        this.approxNodeArea = diff / 3 //Account for RGB pixel count
        let totalArea = this.cropArea * 3 //Account for RGB pixel count
        this.coverage = (Math.round(diff / totalArea * 100))
      },

      //Find area of [{x, y}, {x, y}...] vertices
      calcPolygonArea(vertices) {
        var total = 0;

        for (var i = 0, l = vertices.length; i < l; i++) {
          var addX = vertices[i].x;
          var addY = vertices[i == vertices.length - 1 ? 0 : i + 1].y;
          var subX = vertices[i == vertices.length - 1 ? 0 : i + 1].x;
          var subY = vertices[i].y;

          total += (addX * addY * 0.5);
          total -= (subX * subY * 0.5);
        }

        return Math.abs(total);
      },
      inside(point, vertices) {
        var x = point.x,
          y = point.y;

        var inside = false;
        for (var i = 0, j = vertices.length - 1; i < vertices.length; j = i++) {
          var xi = vertices[i].x,
            yi = vertices[i].y;
          var xj = vertices[j].x,
            yj = vertices[j].y;

          var intersect = ((yi > y) != (yj > y)) &&
            (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
          if (intersect) inside = !inside;
        }

        return inside;
      },

      //Create the "grid" of nodes and their attributes
      initNodes() {
        var points = []

        let width, height, dWidth, dHeight, area;
        let id = 1;

        for (var i = this.cropLimits.y.min; i < this.cropLimits.y.max;) {
          var subPoints = []
          var heightFlag = false
          for (var j = this.cropLimits.x.min; j < this.cropLimits.x.max;) {
            //Noise used for size and position
            var noise = this.ps.noise(j, i);

            //Image width and height
            width = Math.round(this.ps.map(noise, 0, 1, this.minDiseaseWidth, this.maxDiseaseWidth, true)) //Width of actual image
            height = Math.round(width / this.disease.ratio) //height of actual image

            //Actual node width and height

            dWidth = Math.round(width * this.disease.d.width) //Max Width of actual disease
            dHeight = Math.round(height * this.disease.d.height) //Max Height of actual disease
            area = Math.round(width * height * this.disease.d.area)

            if (dWidth < 1)
              dWidth = 1
            if (dHeight < 1)
              dHeight = 1


            //rotation
            var rotation = Math.random() * 20
            if (Math.random() < 0.5)
              rotation = rotation * -1;

            if (this.disease.ratio > 2)
              rotation = 0

            var point = {
              id: id++,
              x: j,
              y: i,
              w: width,
              h: height,
              area: area,
              rotation: rotation,
              noise: noise,
              neighbors: []
            }

            // Check if inside crop outline
            if (this.cropOutline) {
              tl = {
                x: point.x + (this.disease.d.minx * point.w),
                y: point.y + (this.disease.d.miny * point.h)
              };
              tr = {
                x: tl.x + (this.disease.d.width * point.w),
                y: tl.y
              }
              bl = {
                x: tl.x,
                y: point.y + (this.disease.d.maxy * point.h)
              }
              br = {
                x: tr.x,
                y: bl.y
              }

              //Check if 4 corners are in crop outline
              if (!this.inside(tl, this.cropOutline)) {
                j++;
                continue;
              }
              if (!this.inside(tr, this.cropOutline)) {
                j++;
                continue;
              }
              if (!this.inside(bl, this.cropOutline)) {
                j++;
                continue;
              }
              if (!this.inside(br, this.cropOutline)) {
                j++;
                continue;
              }
            }

            j += Math.ceil(dWidth / 2)
            heightFlag = true
            subPoints.push(point)
          }
          if (heightFlag) {
            i += Math.ceil(dHeight / 2)
            points.push(subPoints)
          } else {
            i++
          }

        } //END creating all nodes

        //If array[i][j] exists return it else null
        const inArray = function(i, j, array) {
          if (i < 0)
            return null
          if (j < 0)
            return null

          if (i < array.length && j < array[i].length) {
            return array[i][j]
          }
          return null
        }

        // Set neighbors of node for faster generation and more "clump" looking
        // generation. Also add node to single dimension array hiddenNodes.
        var point, tl, tr, bl, br
        for (var i = 0; i < points.length; i++) {
          for (var j = 0; j < points[i].length; j++) {
            point = points[i][j];

            let top = inArray(i - 1, j, points)
            let right = inArray(i, j + 1, points)
            let bottom = inArray(i + 1, j, points)
            let left = inArray(i, j - 1, points)

            top != null ? point['neighbors'].push(top) : null
            right != null ? point['neighbors'].push(right) : null
            bottom != null ? point['neighbors'].push(bottom) : null
            left != null ? point['neighbors'].push(left) : null


            this.hiddenNodes.push(point);
          }
        }
      },



    }
  }
</script>

<template>
  <div>
    <template v-if="!isQuiz">
      <div class="row">
        <h3>Example Coverage: <span>{{coverage}}%</span></h3>
        <!-- Tooltip to show the added offset on frontend -->
        <!-- <div class="custom-tooltip" v-if="disease.offset && disease.offset != 0">+offset<span class="custom-tooltiptext">{{disease.offset}}%</span></div> -->
      </div>
      <h4 v-if="!disease.outline">Add an outline to disease to create more accurate generation.</h4>
    </template>


    <img id="hidden-crop-image" :src="cropImgSrc" style="display: none;" />
    <img id="hidden-disease-image" :src="diseaseImgSrc" style="display: none;" />
    <div ref="canvas"></div>
    <div class="row">
      <div class="col-11 pb-4">
        <vue-slider v-if="!isQuiz" v-model="slider" :disabled="loading" :lazy="true" tooltip="none" :max="85" :min="0" :value="20" />
      </div>
      <div class="col-1">
        <div class="sk-circle" v-if="loading || sliderUpdated">
          <span id="loading-percent"></span>
          <div class="sk-circle1 sk-child"></div>
          <div class="sk-circle2 sk-child"></div>
          <div class="sk-circle3 sk-child"></div>
          <div class="sk-circle4 sk-child"></div>
          <div class="sk-circle5 sk-child"></div>
          <div class="sk-circle6 sk-child"></div>
          <div class="sk-circle7 sk-child"></div>
          <div class="sk-circle8 sk-child"></div>
          <div class="sk-circle9 sk-child"></div>
          <div class="sk-circle10 sk-child"></div>
          <div class="sk-circle11 sk-child"></div>
          <div class="sk-circle12 sk-child"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  /* Loading Spiner Percent */
  #loading-percent {
    position: absolute;
    left: 5px;
    top: 5px;
  }

  /* Offset Tooltip container */
  .custom-tooltip {
    position: relative;
    display: inline-block;
    padding-left: 5px;
    padding-top: 3px;
  }

  /* Offset Tooltip text */
  .custom-tooltip .custom-tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    border-radius: 6px;

    position: absolute;
    z-index: 1;
  }

  /* Offset Show the tooltip text when you mouse over the tooltip container */
  .custom-tooltip:hover .custom-tooltiptext {
    visibility: visible;
  }

  /* Loading Circle */
  .sk-circle {
    /* margin: 100px auto; */
    width: 40px;
    height: 40px;
    position: relative;
  }

  .sk-circle .sk-child {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .sk-circle .sk-child:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #333;
    border-radius: 100%;
    -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
    animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
  }

  .sk-circle .sk-circle2 {
    -webkit-transform: rotate(30deg);
    -ms-transform: rotate(30deg);
    transform: rotate(30deg);
  }

  .sk-circle .sk-circle3 {
    -webkit-transform: rotate(60deg);
    -ms-transform: rotate(60deg);
    transform: rotate(60deg);
  }

  .sk-circle .sk-circle4 {
    -webkit-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
  }

  .sk-circle .sk-circle5 {
    -webkit-transform: rotate(120deg);
    -ms-transform: rotate(120deg);
    transform: rotate(120deg);
  }

  .sk-circle .sk-circle6 {
    -webkit-transform: rotate(150deg);
    -ms-transform: rotate(150deg);
    transform: rotate(150deg);
  }

  .sk-circle .sk-circle7 {
    -webkit-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }

  .sk-circle .sk-circle8 {
    -webkit-transform: rotate(210deg);
    -ms-transform: rotate(210deg);
    transform: rotate(210deg);
  }

  .sk-circle .sk-circle9 {
    -webkit-transform: rotate(240deg);
    -ms-transform: rotate(240deg);
    transform: rotate(240deg);
  }

  .sk-circle .sk-circle10 {
    -webkit-transform: rotate(270deg);
    -ms-transform: rotate(270deg);
    transform: rotate(270deg);
  }

  .sk-circle .sk-circle11 {
    -webkit-transform: rotate(300deg);
    -ms-transform: rotate(300deg);
    transform: rotate(300deg);
  }

  .sk-circle .sk-circle12 {
    -webkit-transform: rotate(330deg);
    -ms-transform: rotate(330deg);
    transform: rotate(330deg);
  }

  .sk-circle .sk-circle2:before {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
  }

  .sk-circle .sk-circle3:before {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
  }

  .sk-circle .sk-circle4:before {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
  }

  .sk-circle .sk-circle5:before {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
  }

  .sk-circle .sk-circle6:before {
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
  }

  .sk-circle .sk-circle7:before {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
  }

  .sk-circle .sk-circle8:before {
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
  }

  .sk-circle .sk-circle9:before {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
  }

  .sk-circle .sk-circle10:before {
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
  }

  .sk-circle .sk-circle11:before {
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
  }

  .sk-circle .sk-circle12:before {
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
  }

  @-webkit-keyframes sk-circleBounceDelay {

    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }

    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes sk-circleBounceDelay {

    0%,
    80%,
    100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    }

    40% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/DynamicDisease.vue